import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import NavigationBar from '../../../components/Navigationbar/Navigationbar';
import { post, Token } from '../../../Script/Session';
import { Box, Link, Table, Typography } from '@mui/joy';

function DetailsViewer() {
    const { id } = useParams();
    const [data, setdata] = useState();
    const [wit, setWit] = useState("90.5%");
    useEffect(() => {
        function f() {
            let body = {};
            body.token = Token.get();
            body.action = "get_userdetails";
            body.id = Number(id);
            let response = post(body, "/punktekonto");
            setdata(JSON.parse(response));
        }
        setTimeout(() => {
            f();
        }, 15);
    }, []);
    if (!data) {
        return (<>Loading</>);
    }
    return (
        <>
            <Box
                sx={{
                    width: wit,
                    position: "fixed",
                    top: 0,
                    right: 0,
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    bgcolor: "background.body",
                    borderLeft: "1px solid",
                    borderColor: "divider",
                    overflowY: "auto",
                }}
            >
                <Typography color='danger'>Diese Werte werden nach dem Normalfall berechnet falls ein Administrator eingreift können werte abweichen!</Typography>
                <Table>
                    <thead>
                        <tr>
                            <th>Feld</th>
                            <th>Erhaltene Punkte</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><Typography level="title-md">Funktionen</Typography></td>
                            <td></td>
                        </tr>
                        {
                            data.groups.map((item) => {
                                return (
                                    <tr>
                                        <td>{item.name}</td>
                                        <td>{item.points}</td>
                                    </tr>
                                )
                            })
                        }
                        <tr>
                            <td><Typography level="title-md">Aktivitäten</Typography></td>
                            <td></td>
                        </tr>
                        {
                            data.aktivity.sort((a, b) => b.time - a.time).map((item) => {
                                return (
                                    <tr>
                                        <td><Link href={window.location.origin + "/aktivityviewer/"+ item.aktivity}>{item.reason}</Link></td>
                                        <td>{item.points}</td>
                                    </tr>
                                )
                            })
                        }
                        <tr>
                            <td><Typography level="title-md">Durch System/Vergabe erlangte Punkte</Typography></td>
                            <td>{data.sys}</td>
                        </tr>
                    </tbody>
                </Table>
                {
                    data.sys < 0 && (
                        <Typography color='danger'>Werte kleiner 0 sind nicht üblich hier wurden manuelle Veränderungen vorgenommen</Typography>
                    )
                }
            </Box>
            <NavigationBar state={"home"} back={false} />
        </>
    )
}

export default DetailsViewer
